import { render, staticRenderFns } from "./ApiOverview.vue?vue&type=template&id=28c7fb5b&scoped=true&"
import script from "./ApiOverview.vue?vue&type=script&lang=js&"
export * from "./ApiOverview.vue?vue&type=script&lang=js&"
import style0 from "./ApiOverview.vue?vue&type=style&index=0&id=28c7fb5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c7fb5b",
  null
  
)

export default component.exports